import React from "react";
import { PortfolioAssetField } from "forms/fields";
import sortBy from "lodash/sortBy";
import PropTypes from "prop-types";

const PortfolioAsset = (props) => {
  const {
    assetNames,
    formik: { setFieldValue, values },
    getSpaces,
    portfolios,
  } = props;
  const resetAssets = () => setFieldValue("asset", null);
  const { asset, deal, portfolio } = values;
  const assets = portfolio
    ? sortBy(
        assetNames.filter((a) => a.portfolio.id === portfolio.id),
        ["name"]
      )
    : [];

  return (
    <PortfolioAssetField
      asset={asset}
      assets={assets}
      isDisabled={!!deal && !!deal.id}
      onSelectAsset={getSpaces}
      onSelectPortfolio={resetAssets}
      portfolio={portfolio}
      portfolios={portfolios}
      isBroker
      isSingleAsset
    />
  );
};

PortfolioAsset.propTypes = {
  assetNames: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  getSpaces: PropTypes.func.isRequired,
  formik: PropTypes.shape({
    setFieldValue: PropTypes.func,
    values: PropTypes.shape({
      deal: PropTypes.object,
      asset: PropTypes.object,
      portfolio: PropTypes.object,
    }),
  }),
};

export default PortfolioAsset;
